import { getReloadSafety } from './reload-blockers';
import { LOADED_WEB_BUILD_ID, tryReloadForBuild } from './web-build-identity';

/** Legacy callers cannot reload without an identified target and complete safety. */
export function autoReloadHiddenTabOnce(latest: string | null = null): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return tryReloadForBuild({
      loaded: LOADED_WEB_BUILD_ID,
      latest,
      safety: getReloadSafety(),
      idle: document.visibilityState === 'hidden',
      storage: window.sessionStorage,
      reload: () => window.location.reload(),
    });
  } catch {
    return false;
  }
}
